import { render, staticRenderFns } from "./further-options.vue?vue&type=template&id=87f0b48a"
import script from "./further-options.vue?vue&type=script&lang=js"
export * from "./further-options.vue?vue&type=script&lang=js"
import style0 from "./further-options.vue?vue&type=style&index=0&id=87f0b48a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports